import { Space, Title, Descriptions, Text } from '@bancobarigui/barihaus';
import { formatarMoeda, formatarArea } from '../utils';

interface AreaConstruidaSectionProps {
  areaConstruida: number;
  valorUnitarioConstruida: number;
  valorParcialConstruida: number;
}

export function AreaConstruidaSection({
  areaConstruida,
  valorUnitarioConstruida,
  valorParcialConstruida,
}: AreaConstruidaSectionProps) {
  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Title level={4}>Área construída averbada</Title>
      <Descriptions
        bordered
        size="small"
        column={1}
        items={[
          {
            key: '1',
            label: 'Área (m²)',
            children: `${formatarArea(areaConstruida)} m²`,
          },
          {
            key: '2',
            label: 'Valor unitário (R$/m²)',
            children: formatarMoeda(valorUnitarioConstruida),
          },
          {
            key: '3',
            label: 'Valor parcial (R$)',
            children: (
              <Text style={{ fontWeight: 600, color: '#1890ff' }}>
                {formatarMoeda(valorParcialConstruida)}
              </Text>
            ),
          },
        ]}
      />
    </Space>
  );
}
